(function () {
  var table = document.getElementById("tire-compare-table");
  var empty = document.getElementById("tire-compare-empty");
  if (!table || !window.SpecrTireCompare) return;

  var CATALOG_API = "/apps/specr/api/tire-compare-catalog";
  var catalogByHandle = null;
  var catalogPromise = null;

  var SPECS = [
    { key: "size", label: "Size", isSizeRow: true },
    { key: "season", label: "Season" },
    { key: "speedLoad", label: "Speed / load" },
    { key: "utqg", label: "UTQG" },
    { key: "studdable", label: "Studdable" },
    { key: "runFlat", label: "Run-flat" },
    { key: "price", label: "Price (each)" },
    { key: "setOf4", label: "Set of 4" },
  ];

  function escHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function currentVariant(item) {
    var variants = item.variants || [];
    if (!variants.length) return null;
    return (
      variants.find(function (v) {
        return String(v.variantId) === String(item.variantId);
      }) || variants[0]
    );
  }

  function itemSpecValue(item, key) {
    var v = currentVariant(item);
    if (v) {
      if (key === "season") return v.season || item.season;
      if (key === "speedLoad") return v.speedLoad || item.speedLoad;
      if (key === "utqg") return v.utqg || item.utqg;
      if (key === "studdable") return v.studdable || item.studdable;
      if (key === "runFlat") return v.runFlat || item.runFlat;
      if (key === "price") {
        if (v.price != null && !isNaN(v.price)) return "$" + Number(v.price).toFixed(2);
      }
    }
    return item[key];
  }

  function setOf4ForItem(item) {
    var v = currentVariant(item);
    var priceNum =
      v && v.price != null && !isNaN(v.price)
        ? Number(v.price)
        : item.priceNum != null && !isNaN(item.priceNum)
          ? item.priceNum
          : null;
    if (priceNum != null) return "$" + (priceNum * 4).toFixed(2);
    return "—";
  }

  function normalizeCatalogVariant(v) {
    return {
      variantId: String(v.variantId),
      tireSize: v.tireSize || "",
      price: v.price != null && !isNaN(v.price) ? Number(v.price) : null,
      season: v.season || "",
      speedLoad: v.speedLoad || "",
      utqg: v.utqg || "",
      studdable: v.studdable || "",
      runFlat: v.runFlat || "",
      available: v.available !== false,
    };
  }

  function loadCatalog() {
    if (catalogPromise) return catalogPromise;
    catalogPromise = fetch(CATALOG_API, { headers: { Accept: "application/json" } })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        catalogByHandle = {};
        ((data && data.products) || []).forEach(function (entry) {
          if (!entry || !entry.handle) return;
          catalogByHandle[entry.handle] = {
            variants: (entry.variants || []).map(normalizeCatalogVariant),
          };
        });
      })
      .catch(function () {
        catalogByHandle = {};
      });
    return catalogPromise;
  }

  function enrichItemsFromCatalog(items) {
    var needsFetch = [];
    items.forEach(function (item) {
      if (!item.handle) return;
      if (item.variants && item.variants.length) return;
      var cat = catalogByHandle && catalogByHandle[item.handle];
      if (cat && cat.variants && cat.variants.length) {
        window.SpecrTireCompare.enrichVariants(item.handle, cat.variants);
        return;
      }
      needsFetch.push(item.handle);
    });
    if (!needsFetch.length) return Promise.resolve(window.SpecrTireCompare.list());
    return Promise.all(
      needsFetch.map(function (handle) {
        return fetch(CATALOG_API + "?handle=" + encodeURIComponent(handle), {
          headers: { Accept: "application/json" },
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            var entry = (data && data.product) || ((data.products || [])[0] || null);
            if (entry && entry.variants && entry.variants.length) {
              var normalized = entry.variants.map(normalizeCatalogVariant);
              if (catalogByHandle) {
                catalogByHandle[entry.handle] = { variants: normalized };
              }
              window.SpecrTireCompare.enrichVariants(entry.handle, normalized);
            }
          })
          .catch(function () {});
      })
    ).then(function () {
      return window.SpecrTireCompare.list();
    });
  }

  function sizeCellHtml(item) {
    var variants = item.variants || [];
    if (variants.length <= 1) {
      var only = variants[0];
      return escHtml(only ? only.tireSize : item.size || "—");
    }
    var html =
      '<select class="tire-compare-size-select" data-compare-handle="' +
      escHtml(item.handle) +
      '" aria-label="Select tire size for ' +
      escHtml(item.title || "tire") +
      '">';
    variants.forEach(function (v) {
      html +=
        '<option value="' +
        escHtml(v.variantId) +
        '"' +
        (String(v.variantId) === String(item.variantId) ? " selected" : "") +
        ">" +
        escHtml(v.tireSize) +
        (v.available === false ? " (sold out)" : "") +
        "</option>";
    });
    html += "</select>";
    return html;
  }

  function render() {
    var items = window.SpecrTireCompare.list();
    if (!items.length) {
      table.innerHTML = "";
      table.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    table.hidden = false;

    var head =
      '<thead><tr><th scope="col">Spec</th>' +
      items
        .map(function (item, i) {
          return (
            "<th scope=\"col\">" +
            '<a href="' +
            escHtml(item.url || "#") +
            '">' +
            escHtml(item.title || "Tire " + (i + 1)) +
            "</a>" +
            ' <button type="button" class="tire-compare-remove" data-remove="' +
            escHtml(item.variantId) +
            '" aria-label="Remove">×</button></th>'
          );
        })
        .join("") +
      "</tr></thead>";

    var bodyRows = SPECS.map(function (spec) {
      return (
        "<tr><th scope=\"row\">" +
        spec.label +
        "</th>" +
        items
          .map(function (item) {
            if (spec.isSizeRow) {
              return "<td>" + sizeCellHtml(item) + "</td>";
            }
            var val = itemSpecValue(item, spec.key);
            if (spec.key === "setOf4") val = setOf4ForItem(item);
            return "<td>" + escHtml(val || "—") + "</td>";
          })
          .join("") +
        "</tr>"
      );
    });

    var actionRow =
      "<tr class=\"tire-compare-actions\"><th scope=\"row\">Actions</th>" +
      items
        .map(function (item) {
          return (
            "<td>" +
            '<a class="specr-btn specr-btn--primary" style="display:inline-flex;margin-bottom:0.5rem;font-size:14px;padding:0.4rem 0.8rem;" href="' +
            escHtml(item.url || "#") +
            '">View tire</a><br>' +
            '<a class="specr-btn specr-btn--secondary" style="display:inline-flex;font-size:14px;padding:0.4rem 0.8rem;" href="/pages/customer-page?intent=installation">Book install</a>' +
            "</td>"
          );
        })
        .join("") +
      "</tr>";

    table.innerHTML =
      '<div class="tire-compare-print-hint"><button type="button" onclick="window.print()" class="specr-btn specr-btn--secondary">Print comparison</button></div>' +
      '<table class="tire-compare-table">' +
      head +
      "<tbody>" +
      bodyRows.join("") +
      actionRow +
      "</tbody></table>";

    table.querySelectorAll("[data-remove]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        window.SpecrTireCompare.remove(btn.getAttribute("data-remove"));
      });
    });

    table.querySelectorAll(".tire-compare-size-select").forEach(function (sel) {
      sel.addEventListener("change", function () {
        var handle = sel.getAttribute("data-compare-handle");
        var variantId = sel.value;
        if (handle && variantId) {
          window.SpecrTireCompare.selectVariant(handle, variantId);
        }
      });
    });
  }

  function init() {
    loadCatalog()
      .then(function () {
        return enrichItemsFromCatalog(window.SpecrTireCompare.list());
      })
      .then(function () {
        render();
      });
  }

  window.addEventListener("specr:tire-compare-changed", function () {
    enrichItemsFromCatalog(window.SpecrTireCompare.list()).then(function () {
      render();
    });
  });

  init();
})();
